import React from 'react'
import { Box, MenuItem } from '@mui/material'
import Select, { Icon } from '@/components/common/Select'
import { SupportedTicker, TICKERS_MAP_BY_NAME, TICKERS } from '@/constants/token'

interface AssetSelectProps {
  value?: SupportedTicker | ''
  onChange: (value: SupportedTicker | '') => void
}

const options = TICKERS.map((option) => ({ ...option, value: option.name }))

const AssetSelect = ({ value, onChange }: AssetSelectProps) => {
  return (
    <Select<SupportedTicker | ''>
      value={value}
      onChange={(event) => {
        onChange(event.target.value as SupportedTicker | '')
      }}
      displayEmpty
      renderLabel={(value) => {
        return TICKERS_MAP_BY_NAME?.[value]?.name
      }}
      renderIcon={(value) => (
        <Icon
          src={TICKERS_MAP_BY_NAME?.[value]?.logoSrcSet.brc}
          alt={
            options.find((option) => {
              return option.value === value
            })?.value
          }
        />
      )}
      renderEmpty={() => {
        return 'All Asset'
      }}
      sx={{ height: 40, gridArea: 'asset' }}
    >
      <MenuItem sx={{ width: '100%', height: 40 }} value={''}>
        All Asset
      </MenuItem>
      {options.map((option) => (
        <MenuItem
          disabled={option?.disabled}
          key={option.value}
          sx={{ width: '100%', height: 40 }}
          value={option.value}
        >
          <Box sx={{ display: 'flex', alignItems: 'center', columnGap: 8, width: '100%' }}>
            <Icon src={option.logoSrcSet.brc} alt={option.name} />
            {option.name}
          </Box>
        </MenuItem>
      ))}
    </Select>
  )
}

export default AssetSelect
